import { observable } from 'mobx';
import BaseSwiperStore from '@src/components/swiper/base-swiper/store';
import Video from '@src/components/video';
import toWebpImage from '@src/utils/to-webp-image';
import Toast from '@src/business-components/common-message';
import getPageLocalesData from '@src/global-locales/get-page-locales-data';
const pageLocalesData = getPageLocalesData();

class featurePageStore {
  constructor(props = {}) {
    Object.assign(this, { ...props });
  }
  @observable
  featureList = [
    {
      item_img: toWebpImage(require('./images/feature-img1.jpg')),
      item_title: pageLocalesData.feature.feature1_text1 + '\n' + pageLocalesData.feature.feature1_text2,
      item_video: 'https://static-omni-mechabreak.seasungames.com/uploads/202506/1750085044595_1749733550164_byzc01.mp4',
      num_img: toWebpImage(require('./images/01.png')),
      text: pageLocalesData.feature.text
    },
    {
      item_img: toWebpImage(require('./images/feature-img2.jpg')),
      item_title: pageLocalesData.feature.feature2_text1 + '\n' + pageLocalesData.feature.feature2_text2,
      item_video: 'https://static-omni-mechabreak.seasungames.com/uploads/202506/1750085044595_1749733550164_jbDIY02.mp4',
      num_img: toWebpImage(require('./images/02.png')),
      text: pageLocalesData.feature.text
    },
    {
      item_img: toWebpImage(require('./images/feature-img3.jpg')),
      item_title: pageLocalesData.feature.feature3_text1 + '\n' + pageLocalesData.feature.feature3_text2,
      item_video: 'https://static-omni-mechabreak.seasungames.com/uploads/202506/1750085044595_1749733550164_msmk03.mp4',
      num_img: toWebpImage(require('./images/03.png')),
      text: pageLocalesData.feature.text
    },
    {
      item_img: toWebpImage(require('./images/feature-img4.jpg')),
      item_title: pageLocalesData.feature.feature4_text1 + '\n' + pageLocalesData.feature.feature4_text2,
      item_video: 'https://static-omni-mechabreak.seasungames.com/uploads/202506/1750085044595_1749733550164_jxyDIY04.mp4',
      num_img: toWebpImage(require('./images/04.png')),
      text: pageLocalesData.feature.text
    }
  ];
  featureSwiper = new BaseSwiperStore({
    swiperOptions: {
      loop: true,
      // autoplay: {
      //   disableOnInteraction: false,
      //   delay: 5000
      // },
      observe: true,
      observeParents: true,
      spaceBetween: 0,
      effect: 'fade',
      fadeEffect: {
        crossFade: true
      }
    }
  });
  // page6数据
  @observable page6Data;
  /**
   * 点击播放视频
   */
  onClickPlayPv = url => {
    if (url) {
      Video.append({
        src: url,
        onCloseCallback: () => {
          this.videoPlayState = false;
        }
      });
    } else {
      Toast.info(`${pageLocalesData.global.comming_soon}`);
    }
  };

  // 是否激活
  @observable isActive = false;

  use() {
    // const Part6Date = useLayerData('featurePageData');
    // useEffect(
    //   () => {
    //     if (!Part6Date) {
    //       return;
    //     }
    //     this.page6Data = Part6Date;
    //     this.featureList = Part6Date.featureList;
    //   },
    //   [Part6Date]
    // );
  }
}

export default featurePageStore;
